import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { Button } from '../components/ButtonElements'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { InfoContainer3, InfoWrapper, TextImageSection, TextBlock, ImageBlock, Tile, TilesContainer } from '../components/InfoSection/InfoElements'
import { animateScroll as scroll } from 'react-scroll';

import { Link } from  'react-router-dom'


import img1 from '../images/pogrzeby-humanistyczne.png';
import img2 from '../images/pozegnanie-pupila.png';
import img3 from '../images/living-funerals.png';
import img4 from '../images/wieczory-pamieci.png';

import img5 from '../images/nowe/ceremonie.png';

import img6 from '../images/nowe/dowolnie.png';


const Page2 = () => {
    const location = useLocation();
    useEffect(() => {
  if (location.hash) {
    const id = location.hash.replace("#", "");
    // ⏱️ daj Reactowi chwilę na render sekcji
    setTimeout(() => {
      handleScroll(id);
    }, 100);
  }
}, [location]);

    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    const handleScroll = (id) => {
      const element = document.getElementById(id);
      const navbarHeight = 80; // dopasuj do swojego navbara w px
      if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY - navbarHeight;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    };

    const [hover, setHover] = useState(false)
    
        const onHover = () => {
            setHover(!hover)
        }
    const toggleHome = () => {
      scroll.scrollTo(20, { smooth: true, duration: 600 });
    };

    return (
        <>
            <Navbar toggle={toggle} />
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <InfoContainer3 lightBg='true'>
                <InfoWrapper>
                            <div>
<TextImageSection>
                <TextBlock>
                      <h2>Idea</h2>
  <p>
    Każde życie jest jedyne i niepowtarzalne. Wierzę, że pożegnania mogą być czymś więcej niż tylko formalnym rytuałem – mogą stać się piękną celebracją tego, co było najcenniejsze. To czas, by zatrzymać się, poczuć wdzięczność i wspólnotę, by uhonorować pamięć i miłość.
  </p>
  <p>
    Tworzę ceremonie świeckie, rytuały indywidualne oraz celebracje życia, które zakorzenione są w uduchowionej, ale pozbawionej religii duchowości – opartej na obecności, szacunku, prawdzie i pięknie. Każda uroczystość jest tworzona na miarę osoby i jej bliskich, w zgodzie z tym, co ważne, i z wartościami, które pozostają w sercach.
  </p>
                </TextBlock>
                <ImageBlock>
                    <img src={img5} alt="Atenida" />
                </ImageBlock>
    </TextImageSection>

      <hr></hr>

      <TilesContainer>
      <Tile
        bg={img1}
        onClick={() => handleScroll("pamieci")}
      >
        Ceremonie<br></br>pamięci życia
      </Tile>

      <Tile
        bg={img2}
        onClick={() => handleScroll("pupil")}
      >
        Pożegnanie<br></br>Pupila
      </Tile>

      <Tile
        bg={img3}
        onClick={() => handleScroll("living")}
      >
        Living<br></br>Funerals
      </Tile>

      <Tile
        bg={img4}
        onClick={() => handleScroll("wieczory")}
      >
        Wieczory<br></br>Pamięci
      </Tile>
    </TilesContainer>

<hr></hr>


  <h2>Jak wygląda proces współpracy?</h2>

  <h3>1. Kontakt</h3>
  <p>
    Pierwszym krokiem jest szybki kontakt ze mną – telefoniczny lub mailowy. W sytuacjach związanych z pożegnaniem bliskiej osoby czas jest bardzo ważny, dlatego reaguję tak szybko, jak to możliwe.
  </p>

  <h3>2. Rozpoznanie potrzeb</h3>
  <p>
    Na początku wspólnie ustalamy, czego naprawdę potrzebujesz w tym szczególnym momencie – czy będzie to pełna organizacja uroczystości, czy tylko prowadzenie ceremonii. Pomagam Ci odnaleźć rozwiązanie, które będzie najbardziej wspierające.
  </p>

  <h3>3. Wybór pakietu</h3>
  <p>
    Na stronie znajdziesz opis różnych pakietów. Każdy z nich ma inny zakres i przebieg – od kompleksowej organizacji po samo prowadzenie ceremonii. Dzięki temu możesz dopasować wsparcie do swoich potrzeb i możliwości.
  </p>

  <h3>4. Rozmowa wstępna</h3>
  <p>
    Umawiamy się na spotkanie – w Twoim domu lub online. To moment, w którym poznaję historię życia bliskiej osoby oraz to, co było dla niej i dla Was najważniejsze. Proszę o przygotowanie pamiątek, zdjęć, listów, wspomnień – tego, co oddaje esencję jej życia i pozwala uhonorować przejście z formy fizycznej do obecności w pamięci, miłości i energii.
  </p>
  <p>(Przygotuję również krótki przewodnik, który pomoże Ci zebrać te materiały).</p>

  <h3>5. Projekt ceremonii</h3>
  <p>
    Na podstawie naszej rozmowy tworzę szkic uroczystości – opis, scenariusz i rytuały. Otrzymujesz go w formie dokumentu lub omawiamy go podczas rozmowy. Masz możliwość wniesienia uwag, tak aby całość w pełni odzwierciedlała Wasze potrzeby i uczucia.
  </p>

  <h3>6. Ostatnie uzgodnienia</h3>
  <p>
    Na dzień lub dwa przed ceremonią kontaktuję się ponownie, aby upewnić się, że wszystkie szczegóły są dopięte, a Ty czujesz się spokojnie i bezpiecznie.
  </p>

  <h3>7. Ceremonia</h3>
  <p>
    Prowadzę ceremonię, dbając o atmosferę, obecność, piękno i spójność całego wydarzenia. To czas pełen szacunku, ale i życia – wspominamy, celebrujemy i oddzielamy ciało od osoby, podkreślając, że jej obecność trwa nadal w sercach, pamięci i krążącej energii.
  </p>

  <h3>8. Po ceremonii</h3>
  <p>W zależności od wybranego pakietu mogę:</p>
  <ul>
    <li>zadbać o dalszą część wydarzenia (np. organizację przyjęcia upamiętniającego),</li>
    <li>zaproponować kolejne spotkania w formie wsparcia coachingowego lub socjoterapeutycznego – aby pomóc Ci odnaleźć się w nowej rzeczywistości po stracie.</li>
  </ul>
<br></br>
  <hr></hr>
<h2>Głębia ceremonii</h2>
  <p>

  </p>
  <TextImageSection>
                    <ImageBlock>
                    <img src={img6} alt="Atenida" />
                </ImageBlock>
                <TextBlock>
    Ceremonie, które przygotowuję, są prowadzone w duchu Celebration of Life – czyli
pogrzebu w duchu świętowania życia. To popularna na Zachodzie forma pożegnania,
koncentrująca się na celebracji i upamiętnieniu życia bliskiej osoby. Może przybierać różne
formy – od wspólnego posiłku, przez wieczór wspomnień, aż po artystyczne
wydarzenie.Forma jest dowolna, ale każdy element, który pojawia się w takiej ceremonii, jest
zaprojektowany z intencją i uważnością. Nie ma tu przypadków – nawet kolor kwiatów ma
znaczenie i niesie ze sobą symboliczny przekaz.
  <p>
Ceremonia Pamięci Życia to przede wszystkim ceremonia poświęcona pożegnaniu ciała
bliskiej osoby. Jest ona chwilą oddzielenia doczesnej formy od tego, co pozostaje z nami –
miłości, pamięci i obecności.  </p>
  
                </TextBlock>

    </TextImageSection>
  <p>
    To dzień, w którym można puszczać ulubione piosenki Waszej bliskiej osoby, dla której odbywa się ceremonia. Kupić kwiaty, które cieszyły tę osobę.
    Przygotować pokaz zdjęć czy filmów, a nawet zatańczyćrazem - tak, jakbyśmy spełniali marznia o tym, jak chciałaby być zapamiętana. Wszystko, co było ważna i ukochane, ma tu swoje miejsce.
  </p>
  <p>
    Moim zdaniem jest pomóc Ci to zorganizować - tak, aby ten dzień nie był jedynie bolesnym obowiązkiem, ale stał się wspierającym  rytuałem, który zapamiętasz jako piękny. Jako dzień, w którym obok łez pojawiła się także miłość, wdzięczność i poczucie wspólnoty.
  </p>
</div>
<hr></hr>
<div id="pamieci">
  <h2>Ceremonie pamięci życia</h2>
  <p>Ceremonie pamięci życia to humanistyczne, bezwyznaniowe pożegnania w duchu
uziemionej duchowości – tworzone z szacunkiem dla duszy, historii i energii osoby, której
ciało żegnamy. To coś więcej niż rytuał. To uhonorowanie życia i pamięci o ukochanej
osobie, wdzięczności i miłości, które pozostają na zawsze.</p>
  <p>Uziemiona duchowość w moim rozumieniu to przestrzeń, w której duch i człowiek spotykają
się w codzienności. To podejście, które obejmuje pełen wachlarz emocji – od smutku, bólu i
tęsknoty, po wdzięczność, czułość i docenienie życia. Wiem, że w takich chwilach emocji jest
ogrom i że najczęściej przeważa żal. Dlatego, tworząc narrację pożegnania, opieram się
zarówno na intuicji i duchowej wrażliwości, jak i na wiedzy o współczesnych procesach
żałoby. Dbam o to, by wprowadzać równowagę i harmonię w przestrzeń, która została tak
bardzo wzburzona.</p>
<p>Ceremonie pamięci życia są alternatywą dla tradycyjnych pogrzebów. Nie mają sztywnej
formy – mogą odbywać się w plenerze, w sali pożegnań, w ogrodzie, w miejscu szczególnie
bliskim zmarłej osobie lub jej rodzinie. To bezpieczna przestrzeń na przeżywanie emocji:
można płakać, można milczeć, można śmiać się, wspominać, śpiewać. Ważne, by każdy
mógł w niej odnaleźć swój własny sposób przeżywania i pożegnania.</p>
<p>Każda ceremonia jest stworzona indywidualnie – na cześć konkretnej osoby i w zgodzie z jej
historią, wartościami oraz wrażliwością rodziny. W swojej pracy korzystam z Ritual Design
Toolkit (RISE) – zestawu narzędzi do projektowania rytuałów niosących sens i empatię,
opracowanego przez Instytut Dobrej Śmierci.</p>
<p>Równocześnie sięgam po moje autorskie metody, które łączą uważność, symbolikę i pracę z
energią, dzięki czemu każda ceremonia staje się wyjątkowym procesem – głęboko ludzkim,
empatycznym i w pełni dopasowanym do potrzeb bliskich.</p>
<p>Bardzo ważną częścią każdej ceremonii jest tworzenie wspólnoty. Wspólnota to coś, o czym
współczesny świat często zapomina, a to właśnie ona – w chwilach przejścia – przynosi
otuchę, wsparcie i poczucie bycia razem. Dlatego duża część procesu projektowania skupia
się na tym, by ceremonia stała się przestrzenią jednoczącą, w której ludzie mogą spotkać
się w prawdzie, w miłości i we wzajemnym szacunku.</p>
<p>Każda ceremonia zawiera elementy duchowe – ich głębokość i forma zależą od potrzeb i
wrażliwości rodziny.</p>
<p>Jako opiekunka momentów przejścia towarzyszę temu procesowi z czułością i głębokim
zrozumieniem, dbając o to, by ceremonia była nie tylko pożegnaniem z ciałem, ale także
energetycznym przejściem, które przynosi ukojenie, sens i pozwala wejść w nowy etap życia
z większym spokojem.</p>
<p>W chwilach, gdy serce rozdziera ból, ceremonie pamięci życia przypominają także o miłości i
o tym, co trwa. O tym, że w ludzkim doświadczeniu żałoby – tak jak w życiu – jest miejsce i
na cień, i na światło.</p>
                    <Button to="/kontakt" onClick={toggleHome} onMouseEnter={onHover} onMouseLeave={onHover} primary='true' dark='true' big='true'>
                    Kontakt
                    </Button>
</div>
<hr></hr>
<div id="pupil">
  <h2>Pożegnanie Pupila</h2>
  <p>Zwierzęta są częścią naszej rodziny. Towarzyszą nam w codzienności, uczą miłości bez
warunków, wierności i obecności. Gdy odchodzą, zostawiają po sobie ciszę, która boli — ale
też ogrom wdzięczności.</p>
<p>Ceremonie pożegnania pupili, które prowadzę, są rytuałami przejścia – pełnymi czułości i
sensu. Wierzę, że nasze zwierzęta, podobnie jak my, mają duszę, a ich odejście zasługuje
na godne, świadome i piękne uczczenie.</p>
<p>Każde pożegnanie tworzę na cześć konkretnego zwierzęcia – zgodnie z jego charakterem,
historią i relacją, jaka Was łączyła. Czasem to spokojne spotkanie w ogrodzie, czasem
symboliczny spacer, wspólne czytanie listu lub zapalenie świecy. Niezależnie od formy, to
zawsze przestrzeń, w której można zatrzymać się, podziękować i pozwolić odejść z miłością.</p>
<p>Wiem też, jak ważne jest pożegnanie dla pozostałych członków stada – psów, kotów czy
innych zwierząt, które dzieliły codzienność z tym, który odszedł.</p>
<p>Jeśli jest taka możliwość, dbam o to, by mogły zobaczyć ciałko pupila, poczuć jego
obecność i również się pożegnać. Zwierzęta rozumieją więcej, niż często im przypisujemy –
dlatego tworzę przestrzeń, w której także one mogą przejść przez ten moment w spokoju i
zrozumieniu.</p>
<p>W pracy korzystam z Ritual Design Toolkit (RISE) – zestawu Rytuałów Indywidualnych
Niosących Sens i Empatię opracowanego przez Instytut Dobrej Śmierci, a także z moich
autorskich metod, łączących uważność, symbolikę i energetyczne prowadzenie. Dzięki temu
każda ceremonia staje się łagodnym przejściem – zarówno dla zwierzęcia, jak i jego
opiekuna.</p>
<p>Jako opiekunka momentów przejścia, dbam o to, by ceremonia przyniosła ukojenie, spokój i
poczucie domknięcia. Choć te rytuały są zazwyczaj prostsze i krótsze od ludzkich ceremonii,
niosą w sobie tę samą głębię miłości, wdzięczności i szacunku.</p>
<br></br>
                    <Button to="/kontakt" onClick={toggleHome} onMouseEnter={onHover} onMouseLeave={onHover} primary='true' dark='true' big='true'>
                    Kontakt
                    </Button>
</div>
<hr></hr>
<div id="living">
  <h2>Living Funerals</h2>
  <p>Living Funerals to wyjątkowe ceremonie życia – tworzone dla osób, które nadal są wśród
nas, ale chcą już teraz, w pełni świadomie, uczcić swoje istnienie, wdzięczność i miłość,
którą dzielą z bliskimi.</p>
<p>To spotkanie, w którym zamiast żałoby jest obecność, zamiast ciszy – wspólne
wspomnienia, a zamiast smutku – ciepło i bliskość.</p>
<p>Takie ceremonie organizuję dla osób, które zmagają się z ciężką chorobą, czują, że zbliża
się ich czas, i pragną pozostawić po sobie świadectwo życia, nie czekając na moment
odejścia. To czas, by jeszcze raz spojrzeć na swoje życie z miłością, podziękować, pojednać
się i spotkać w kręgu tych, którzy znaczą najwięcej.</p>
<p>Wspólnie tworzymy projekt celebracji życia – dopasowany do potrzeb, charakteru i
wrażliwości osoby, na której cześć powstaje. To może być wspólne oglądanie zdjęć, filmów,
słuchanie ulubionej muzyki, dzielenie się słowami wdzięczności czy symboliczny rytuał
przekazania światła, pamiątki lub błogosławieństwa.</p>
<p>Ja zajmuję się całą organizacją i prowadzeniem, tak by osoba świętująca swoje życie mogła
być po prostu obecna, spokojna i otoczona miłością.</p>
<p>W pracy korzystam z Ritual Design Toolkit (RISE) – zestawu Rytuałów Indywidualnych
Niosących Sens i Empatię opracowanego przez Instytut Dobrej Śmierci, oraz z moich
autorskich metod, które łączą symbolikę, energię i czułość w tworzeniu bezpiecznej, pełnej
serca przestrzeni.</p>
<p>Living Funeral to nie pożegnanie, lecz pełna miłości celebracja życia, wdzięczności i
wspólnoty – moment, w którym można świadomie powiedzieć: byłam, kochałam, żyłam
naprawdę... i jestem, i będę.</p>
<br></br>
                    <Button to="/kontakt" onClick={toggleHome} onMouseEnter={onHover} onMouseLeave={onHover} primary='true' dark='true' big='true'>
                    Kontakt
                    </Button>
</div>
<hr></hr>
<div id="wieczory">
  <h2>Wieczory Pamięci</h2>
  <p>Wieczory Pamięci to spotkania, podczas których wspominamy życie osoby, która już odeszła
— z miłością, czułością i wdzięcznością. To czas, by przywrócić wspomnieniom blask i
poczuć obecność, która trwa mimo upływu czasu.</p>
<p>Choć najczęściej odbywają się wieczorem, mogą mieć miejsce o każdej porze dnia —
wtedy, gdy czujesz, że to odpowiedni moment, by zatrzymać się i wspólnie pobyć z
pamięcią.</p>
<p>Taka ceremonia może odbyć się kilka tygodni, miesięcy lub nawet lat po odejściu bliskiej
osoby. Czasem towarzyszy rocznicy śmierci, urodzinom, a czasem jest po prostu potrzebą
serca — by raz jeszcze uhonorować, podziękować i poczuć więź.</p>
<p>Wieczory Pamięci to forma celebracji życia — nie smutne wspominanie, ale wspólne
świętowanie istnienia. Mogą przybierać różne formy: wspólne oglądanie zdjęć, filmów,
czytanie listów i wspomnień, zapalenie świec, krąg wdzięczności, wspólne milczenie lub
muzykę, która towarzyszyła osobie, na której cześć spotykamy się tego dnia.</p>
<p>Jeśli wiesz, że pogrzeb Twojego bliskiego będzie miał charakter państwowy lub religijny, a
pragniesz nadać mu także osobisty, bardziej symboliczny wymiar — Wieczór Pamięci może
odbyć się przed pochówkiem, jako intymne, humanistyczne pożegnanie w duchu miłości i
życia.</p>
<p>W pracy korzystam z Ritual Design Toolkit (RISE) – zestawu Rytuałów Indywidualnych
Niosących Sens i Empatię opracowanego przez Instytut Dobrej Śmierci, oraz z moich
autorskich metod, które łączą uważność, symbolikę i energetyczne prowadzenie.
Jako opiekunka momentów przejścia, tworzę przestrzeń, w której wspomnienia stają się
żywą obecnością – czułą, piękną i uzdrawiającą.</p>
<p>Bo pamięć to również forma miłości, a Wieczory Pamięci są jej cichym, pełnym światła
świętem.</p>
<br></br>
                    <Button to="/kontakt" onClick={toggleHome} onMouseEnter={onHover} onMouseLeave={onHover} primary='true' dark='true' big='true'>
                    Kontakt
                    </Button>
</div>

<hr></hr>
<div id="dziecko">
  <h2>Ceremonia pożegnania dziecka</h2>
  <p>Utrata dziecka – także nienarodzonego – to jedno z najbardziej delikatnych i poruszających
doświadczeń.</p>
<p>Ceremonie pożegnania dzieci tworzę z największą troską o emocje rodziców i bliskich.</p>
<p>Pomagam im znaleźć przestrzeń, w której mogą wyrazić ból, miłość i pamięć, oraz stworzyć
symboliczne rytuały, które uhonorują istnienie ich dziecka w sposób, jaki czują za najbliższy
sercu.</p>
<p>To moment, w którym czas zatrzymuje się, by uświadomić, że każde życie – niezależnie od
jego długości – jest ważne, znaczące i godne pięknego upamiętnienia.</p>
</div>


<hr></hr>
<div id="cialo">
  <h2>Pożegnanie z ciałem przed kremacją lub pochówkiem</h2>
  <p>Pożegnanie z ciałem bliskiej osoby to wyjątkowo intymny moment, który pozwala stopniowo
oswoić się z rozstaniem i nadać mu znaczenie.</p>
<p>Zazwyczaj odbywa się w wąskim gronie – w dniu kremacji, pogrzebu lub w innym, wybranym
przez rodzinę terminie.</p>
<p>Może to być krótka, spokojna ceremonia, wypełniona symbolami: chwilą ciszy, ułożeniem
kwiatów, zapaleniem świecy, włożeniem do trumny osobistego przedmiotu lub napisaniem
kilku słów pożegnania.</p>
<p>Każdy z tych gestów staje się aktem miłości i wdzięczności, pomagając zrozumieć, że to
ciało odchodzi, ale więź – pozostaje.</p>
</div>

<hr></hr>
<div id="rok">
  <h2>Ceremonie rocznicowe i wspomnieniowe</h2>
  <p>Czasami potrzeba powrotu do wspomnień pojawia się dopiero po czasie – w rocznicę, w
dniu urodzin, albo wtedy, gdy serce samo podpowiada, że warto się zatrzymać.</p>
<p>Ceremonie rocznicowe i wspomnieniowe tworzą przestrzeń do spokojnego, przemyślanego
spotkania z pamięcią o bliskiej osobie.</p>
<p>Mogą przybierać różne formy np. kameralnego Wieczoru Pamięci. Odbywają się w domu, w
ogrodzie, w wynajętej przestrzeni, na cmentarzu lub w plenerze – tam, gdzie czujecie
obecność tej osoby najmocniej.</p>
<p>To spotkania, które ożywiają wspomnienia, przynoszą ukojenie i pozwalają domknąć pewien
etap, a jednocześnie przypominają, że pamięć jest formą obecności.</p>
</div>
<hr></hr>
<div>
<p>💫<Link to='/#jak' style={{ cursor: "pointer", color: "black" , fontSize: '1.2rem', fontWeight: "bold"} }>Zobacz, jak projektuję ceremonie</Link></p>
<p>📖<Link to='/faq' style={{ cursor: "pointer", color: "black" , fontSize: '1.2rem', fontWeight: "bold"} } onClick={toggleHome}>Przeczytaj najczęściej zadawane pytania</Link></p>
<p>💌Jeśli nie znajdziesz tam odpowiedzi lub chcesz porozmawiać o swojej sytuacji, <Link to='/kontakt' style={{ cursor: "pointer", color: "black" , fontSize: '1.2rem', fontWeight: "bold"} } onClick={toggleHome}>napisz
do mnie przez formularz kontaktowy.</Link></p>
<p>🌿A jeśli chcesz poznać mnie bliżej – zapraszam na mój profil: <a style={{ cursor: "pointer", color: "black" , fontSize: '1.2rem', fontWeight: "bold"} } href='https://www.instagram.com/aneta.glowna/' target='_blank'>@aneta.glowna</a></p>
</div>


<hr></hr>
<div>
  <h3>Wybierając osobę, która poprowadzi ceremonię, kieruj się sercem. Zwróć uwagę na jej
wrażliwość, wartości i estetykę — niech będą bliskie Twoim. To daje spokój i poczucie
bezpieczeństwa, że tak ważny moment oddajesz w ręce kogoś, komu naprawdę możesz
zaufać.</h3>
<h3>A jeśli czujesz, że to, co czytasz, jest w zgodzie z Tobą — być może właśnie się
odnaleźliśmy.</h3>
</div>
                </InfoWrapper>

            </InfoContainer3>
            <Footer />
        </>
    )
}

export default Page2